module.exports = __webpack_public_path__ + "img/logo.d44b110c.svg";